export const spyMasterState =  {
    state:() => ({
      isSpyMaster: false
    }),
    mutations: {
      spyMasterGranted(state) {
        state.isSpyMaster = true;
      },
      spyMasterReleased(state) {
        state.isSpyMaster = false;
      }
    },
    actions: {
      requestSpyMaster(context) {
        const teammatesHasSpyMaster = true;

        if(!teammatesHasSpyMaster){
          context.commit("spyMasterGranted", null);
        }
      },
      releaseSpyMaster(context) {
        context.commit("spyMasterReleased", null);
      }
    },
    getters: {
      isSpyMaster: state => {
          return state.isSpyMaster;
      }
    }
};
